import { Theme, ThemeProvider } from "@mui/material"
import React from "react"
import Sb1Theme from "./Sb1Theme"


declare module '@mui/material/styles' {
    interface Theme {
      logo: string
    }
    // allow configuration using `createTheme`
    interface ThemeOptions {
      logo: string
    }
  }

interface CustomThemeContextProps {
    currentTheme: Theme,
    setCurrentTheme: (theme: Theme) => void
}

export const CustomThemeContext = React.createContext<CustomThemeContextProps>({
    currentTheme: Sb1Theme,
    setCurrentTheme: () => {}
})

export const CustomThemeProvider: React.FC = (props) => {
    const { children } = props
    
    const [currentTheme, setCurrentTheme] = React.useState(Sb1Theme)

    const contextValue = {
        currentTheme,
        setCurrentTheme
    }

    return (
        <CustomThemeContext.Provider value={contextValue}>
            <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>
        </CustomThemeContext.Provider>
    )
}